import useBrowserStorage from "../../internal/browserStorage/useBrowserStorage";
import localStorage from "../../internal/localStorage/localStorage";
import useDataConfig from "../useDataConfig";
/**
 *
 * @see https://sail.stripe.me/data/api/useLocalStorage
 */ export default function useLocalStorage(/* Key of the localStorage to interact with */ key) {
    const dataConfig = useDataConfig();
    return useBrowserStorage(dataConfig.browserStorage, localStorage, key);
}

//# sourceMappingURL=useLocalStorage.js.map